import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "group", "button"]
  static values = { limit: { type: Number, default: 20 }, step: { type: Number, default: 20 } }

  connect() {
    this.visibleCount = 0
    this.applyLimit()
  }

  applyLimit() {
    const items = this.itemTargets
    const limit = this.limitValue
    this.visibleCount = Math.min(limit, items.length)

    items.forEach((item, index) => {
      item.style.display = index >= limit ? "none" : ""
    })

    this.updateGroups()
    this.updateButton()
  }

  showMore() {
    const filterCtrl = this.application.getControllerForElementAndIdentifier(this.element, "activity-filter")
    const filterActive = filterCtrl && filterCtrl.currentValue !== "all"

    if (filterActive) {
      const hiddenByPagination = this.itemTargets.filter(i => !i.classList.contains("hidden") && i.style.display === "none")
      const next = Math.min(this.stepValue, hiddenByPagination.length)
      hiddenByPagination.slice(0, next).forEach(item => { item.style.display = "" })
    } else {
      const items = this.itemTargets
      const next = Math.min(this.visibleCount + this.stepValue, items.length)
      for (let i = this.visibleCount; i < next; i++) {
        items[i].style.display = ""
      }
      this.visibleCount = next
    }

    this.updateGroups()
    this.updateButton()
  }

  recalculate() {
    const filterCtrl = this.application.getControllerForElementAndIdentifier(this.element, "activity-filter")
    const filterActive = filterCtrl && filterCtrl.currentValue !== "all"

    if (filterActive) {
      const matchingItems = this.itemTargets.filter(i => !i.classList.contains("hidden"))
      const limit = this.limitValue
      matchingItems.forEach((item, index) => {
        item.style.display = index >= limit ? "none" : ""
      })
      this.itemTargets.filter(i => i.classList.contains("hidden")).forEach(item => {
        item.style.display = "none"
      })
    } else {
      this.applyLimit()
      return
    }

    this.updateGroups()
    this.updateButton()
  }

  updateGroups() {
    this.groupTargets.forEach(group => {
      const items = group.querySelectorAll("[data-show-more-target='item']")
      const allHidden = Array.from(items).every(item =>
        item.style.display === "none" || item.classList.contains("hidden")
      )
      group.style.display = allHidden ? "none" : ""
      group.classList.toggle("hidden", allHidden)
    })
  }

  updateButton() {
    if (!this.hasButtonTarget) return

    const filterCtrl = this.application.getControllerForElementAndIdentifier(this.element, "activity-filter")
    const filterActive = filterCtrl && filterCtrl.currentValue !== "all"

    let remaining
    if (filterActive) {
      const matchingItems = this.itemTargets.filter(i => !i.classList.contains("hidden"))
      const visibleNow = matchingItems.filter(i => i.style.display !== "none").length
      remaining = matchingItems.length - visibleNow
    } else {
      remaining = this.itemTargets.length - this.visibleCount
    }

    if (remaining > 0) {
      this.buttonTarget.style.display = ""
      this.buttonTarget.classList.remove("hidden")
      const countEl = this.buttonTarget.querySelector(".show-more-count")
      if (countEl) countEl.textContent = remaining
    } else {
      this.buttonTarget.style.display = "none"
      this.buttonTarget.classList.add("hidden")
    }
  }
}
